import { IMainMenuViewOption, MenuObject } from '@rbi-ctg/menu';
import { routes } from 'utils/routing';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const optionToUrl = (option: IMainMenuViewOption | MenuObject, isBrowseMenu?: boolean) =>
  `${routes.menu}/${option._type}-${option._id}`;
